import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const Contra = () => {
    const navigate = useNavigate();
    const [cashBankAccounts, setCashBankAccounts] = useState([]);

    const [contra, setContra] = useState({
        date: new Date().toISOString().split('T')[0], // Set current date
        from_account: "",
        to_account: "",
        from_account_id: "",
        to_account_id: "",
        amount: "",
        description: "",
    });
    
    useEffect(() => {
        fetchCashBankAccounts();
    }, []);

    const fetchCashBankAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");

        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}get-accounts`,
                { account_type_ids: [9, 10] }, // Fetch only Cash & Bank accounts
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            setCashBankAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    };

    const handleFromAccountSelection = (e) => {
        const selectedAccount = cashBankAccounts.find(acc => acc.name === e.target.value);
        if (selectedAccount) {
            setContra({
                ...contra,
                from_account_id: selectedAccount.id, // Store ID
                from_account: selectedAccount.name  // Store Name
            });
        } else {
            setContra({ ...contra, from_account_id: "", from_account: e.target.value });
        }
    };

    const handleToAccountSelection = (e) => {
        const selectedAccount = cashBankAccounts.find(acc => acc.name === e.target.value);
        if (selectedAccount) {
            setContra({
                ...contra,
                to_account_id: selectedAccount.id, // Store ID
                to_account: selectedAccount.name  // Store Name
            });
        } else {
            setContra({ ...contra, to_account_id: "", to_account: e.target.value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");

        if (contra.from_account_id === contra.to_account_id) {
            return alert("From Account and To Account cannot be the same.");
        }

        const payload = {
            from_account_id: contra.from_account_id,
            to_account_id: contra.to_account_id,
            amount: parseFloat(contra.amount), // Ensure amount is numeric
            date: contra.date,
            description: contra.description || "", // Ensure description is not undefined
        };

        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}create-contra`, payload, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            alert(`${response.data.message || "Contra entry created successfully!"} Contra Number: ${response.data.contra_number}`);
            navigate("/contra-list");
        } catch (error) {
            console.error("Error creating contra entry:", error);
            alert(error.response?.data?.message || "Error creating contra entry. Please try again.");
        }
    };

    return (
        <Layout>
            <h4>Create Contra Entry</h4>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-2">
                    <Form.Label>Date</Form.Label>
                    <Form.Control type="date" value={contra.date} onChange={(e) => setContra({ ...contra, date: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>From Account</Form.Label>
                    <Form.Control
                        list="cash-bank-accounts"
                        value={contra.from_account}
                        onChange={handleFromAccountSelection}
                    />
                    <datalist id="cash-bank-accounts">
                        {cashBankAccounts.map(account => (
                            <option key={account.id} value={account.name} />
                        ))}
                    </datalist>
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>To Account</Form.Label>
                    <Form.Control
                        list="cash-bank-accounts"
                        value={contra.to_account}
                        onChange={handleToAccountSelection}
                    />
                    <datalist id="cash-bank-accounts">
                        {cashBankAccounts.map(account => (
                            <option key={account.id} value={account.name} />
                        ))}
                    </datalist>
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control type="number" value={contra.amount} onChange={(e) => setContra({ ...contra, amount: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text" value={contra.description} onChange={(e) => setContra({ ...contra, description: e.target.value })} />
                </Form.Group>

                <Button type="submit" variant="primary">Create Contra Entry</Button>
                <Button 
                    variant="secondary" 
                    className="ms-2" 
                    onClick={() => navigate("/contra-list")}
                >
                    View Contras
                </Button>
            </Form>
        </Layout>
    );
};

export default Contra;
